import moment from "moment";

export interface DatePeriod {
  id: number;
  startDate: moment.Moment;
  endDate: moment.Moment;
  label: string;
}

export const DATE_PRESET_OPTIONS: DatePeriod[] = [
  {
    id: 1,
    startDate: moment().startOf("week"),
    endDate: moment().add(1, "day"),
    label: "Jooksev nädal",
  },
  {
    id: 2,
    startDate: moment().subtract(1, "weeks").startOf("week"),
    endDate: moment().subtract(1, "weeks").endOf("week"),
    label: "Eelmine nädal",
  },
  {
    id: 3,
    startDate: moment().startOf("month"),
    endDate: moment().add(1, "day"),
    label: "Jooksev kuu",
  },
  {
    id: 4,
    startDate: moment().subtract(1, "months").startOf("month"),
    endDate: moment().subtract(1, "months").endOf("month"),
    label: "Eelmine kuu",
  },
  {
    id: 5,
    startDate: moment().startOf("year"),
    endDate: moment().add(1, "day"),
    label: "Jooksev aasta",
  },
  {
    id: 6,
    startDate: moment().subtract(1, "year").startOf("year"),
    endDate: moment().subtract(1, "year").endOf("year"),
    label: "Eelmine aasta",
  },
];
